module.exports = __webpack_public_path__ + "img/hobbies.e8fb27d1.svg";